// extracted by mini-css-extract-plugin
export default {"container":"flag__container___2LbS7","text":"flag__text___pSCJ9"};